const hexRegexReduced = /^#[a-fA-F0-9]{3}$/;
const hexRegex = /^#[a-fA-F0-9]{6}$/;
const hexToRgb = function (hexColor) {
    if (hexColor.match(hexRegex)) {
        return {
            red: parseInt(`${hexColor[1]}${hexColor[2]}`, 16),
            green: parseInt(`${hexColor[3]}${hexColor[4]}`, 16),
            blue: parseInt(`${hexColor[5]}${hexColor[6]}`, 16)
        };
    }
    if (hexColor.match(hexRegexReduced)) {
        return {
            red: parseInt(`${hexColor[1]}${hexColor[1]}`, 16),
            green: parseInt(`${hexColor[2]}${hexColor[2]}`, 16),
            blue: parseInt(`${hexColor[3]}${hexColor[3]}`, 16)
        };
    }
    return {
        red: 0,
        green: 0,
        blue: 0
    };
};
const colorToRgba = function (color) {
    return `rgba(${color.red}, ${color.green}, ${color.blue}, ${color.alpha})`;
};
const numberInRange = function (min, max, value) {
    return Math.max(min, Math.min(max, value));
};
export const opacity = function (amount, hexColor) {
    const parsedColor = hexToRgb(hexColor);
    const alpha = numberInRange(0, 1, amount);
    return colorToRgba(Object.assign(Object.assign({}, parsedColor), { alpha }));
};



//////////////////
// WEBPACK FOOTER
// ./src/helpers/Colors.ts
// module id = 88
// module chunks = 0